import { render, staticRenderFns } from "./HKLFlex.vue?vue&type=template&id=61fd4da6&scoped=true&"
import script from "./HKLFlex.vue?vue&type=script&lang=js&"
export * from "./HKLFlex.vue?vue&type=script&lang=js&"
import style0 from "./HKLFlex.vue?vue&type=style&index=0&id=61fd4da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd4da6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fd4da6')) {
      api.createRecord('61fd4da6', component.options)
    } else {
      api.reload('61fd4da6', component.options)
    }
    module.hot.accept("./HKLFlex.vue?vue&type=template&id=61fd4da6&scoped=true&", function () {
      api.rerender('61fd4da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Layout/HKLFlex.vue"
export default component.exports